import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const AddOnProductsScreen = ({ payload, items, series,proceed,addOnPro,erp,editMode, seriesWiseClass }) => {
  
  const [selectedAddOns, setSelectedAddOns] = useState([]);

let addP = [];
if (addOnPro) {
  const parsed = JSON.parse(addOnPro);

  addP = Object.values(parsed).flat().map(ele => ({
    name: ele.name,
    inputs: ele.inputs || {}
  }));
}
    // let addP=addOnPro
    // if(addP){
    //     addP=JSON.parse(addOnPro).map((ele)=>{return {name:ele,or:0}})}
    const [confuse, setConfuse] = useState({});
    const [isChecked, setIsChecked] = useState(erp==1?true:false);
    const [prize, setPrize] = useState([]);
    const [dropMenu, setDropMenu] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [addOnLists, setAddOnLists] = useState([]);
    const [addOnProducts, setAddOnProducts] = useState([]);
    const [addOnInputs, setAddOnInputs] = useState({});

    useEffect(() => {
        setIsLoading(true);
      getAddOnList();
    },[])

    useEffect(() => {
        groupData(items);
    }, [items]);

useEffect(() => {
  if (!addOnLists.length) return;

  const preChecked = addOnLists
    .filter(addOn => addOn.checked === true)
    .map(addOn => ({
      name: addOn.name,
      series: addOn.series
    }));

  setSelectedAddOns(preChecked);

}, [addOnLists]);


//     useEffect(() => {
//   if (editMode && addOnPro && addOnLists.length > 0) {
//     try {
//       const parsedAddOns = JSON.parse(addOnPro);
//       const matchedAddOns = [];
//       parsedAddOns.forEach(name => {
//         const match = addOnLists.find(item => item.name === name);
//         if (match) {
//           matchedAddOns.push({ name, series: match.series });
//         }
//       });
//       setSelectedAddOns(matchedAddOns);
//     } catch (err) {
//       console.error("Invalid addOnProduct JSON", err);
//     }
//   }
// }, [editMode, addOnPro, addOnLists]);
const getSeriesIdByName = (seriesName) => {
  const seriesObj = series?.find(s => s.seriesName === seriesName);
  return seriesObj?.seriesTableId;
};
useEffect(() => {
  if (editMode && addOnPro && addOnLists.length > 0) {
    try {
      const parsed = JSON.parse(addOnPro);

      const selected = [];
      const inputsMap = {};

     Object.entries(parsed).forEach(([seriesName, addOns]) => {
  const seriesId = getSeriesIdByName(seriesName);

  addOns?.forEach(addOn => {
    const match = addOnLists.find(
      item => item.name === addOn.name && item.series === seriesId
    );

    if (match) {
      selected.push({
        name: addOn.name,
        series: match.series
      });

      inputsMap[match.id] = addOn.inputs || {};
    }
  });
});
      setSelectedAddOns(selected);
      setAddOnInputs(inputsMap); // ⭐ VERY IMPORTANT

    } catch (err) {
      console.error("Invalid addOnProduct JSON", err);
    }
  }
}, [editMode, addOnPro, addOnLists]);

useEffect(() => {
  if (addOnProducts && addOnProducts.length > 0) {
    const checkedAddOns = addOnProducts
      // .filter(item => item.checked === true)
      .filter(item => 
  item.checked === true &&
  seriesWiseClass.some(s => 
    (s.series || s?.data?.seriesCategory) === item.series
  )
)
      .map(item => ({
        name: item.name,
        series: item.series,
        id: item.id
      }));
    
    setSelectedAddOns(prev => {
      const combined = [...prev, ...checkedAddOns];
      const map = {};
      combined.forEach(a => {
        map[`${a.name}-${a.series}`] = a;
      });
      return Object.values(map);
    });
  }
}, [addOnProducts]);

    async function getAddOnList() {
  const results = await window.Platform.database.getAddOnsList({});

  if (results?.status) {
    const formatted = results.data.map(item => ({
      ...item,
      conditions: item.conditions ? JSON.parse(item.conditions) : []
    }));

    setAddOnLists(formatted);
    setIsLoading(false);
  } else {
    setIsLoading(false);
  }
}

const handleChange = (addOn) => {
  setSelectedAddOns(prev => {
    const key = `${addOn.name}-${addOn.series}`;
    const exists = prev.find(a => a.name === addOn.name && a.series === addOn.series);
    let updated;
    if (exists) {
      updated = prev.filter(a => !(a.name === addOn.name && a.series === addOn.series));
    } else {
      updated = [...prev, { name: addOn.name, series: addOn.series }];
    }
    return updated;
  });
};

const parseInputTypes = (inputTypesString) => {
  if (!inputTypesString) return [];
  try {
    return JSON.parse(inputTypesString);
  } catch (err) {
    console.error("Error parsing inputTypes:", err);
    return [];
  }
};

const handleAddOnInputChange = (addOnId, fieldName, value) => {
  setAddOnInputs(prev => ({
    ...prev,
    [addOnId]: {
      ...prev[addOnId],
      [fieldName]: value
    }
  }));
};

const buildAddOnCountMap = (arr) => {
  return arr.reduce((acc, item) => {
    acc[item] = (acc[item] || 0) + 1;
    return acc;
  }, {});
};

const getSeriesName = (seriesId) => {
  const seriesObj = series?.find(s => s.seriesTableId === seriesId);
  return seriesObj?.seriesName || seriesId;
};

const getAddOnsBySeriesName = () => {
  if (!seriesWiseClass?.length || !addOnLists.length) return {};
  
  const grouped = {};
  seriesWiseClass.forEach(item => {
    // const seriesId = item.series;
const seriesId = item.series || item?.data?.seriesCategory;
    const seriesName = getSeriesName(seriesId);
    
    const matchingAddOns = addOnLists.filter(addOn => addOn.series === seriesId);
    
    if (matchingAddOns.length > 0) {
      grouped[seriesName] = matchingAddOns;
    }
  });
  
  return grouped;
};

    const getMenu = async (pp) => {
        const body = { id: pp.map(ele => ele.menu) };
        try {
            const response = await window.Platform.database.getAddOnsMenu(body);
            if (response) {
                setDropMenu(response.data);
                setIsLoading(false);
                if (editMode && addOnPro) {
  const parsedAddOns = JSON.parse(addOnPro);

  const addOnCountMap = buildAddOnCountMap(parsedAddOns);

  pp.forEach((pri) => {
    const options = response.data.filter(
      (r) => r.id == pri.menu
    );

    for (let option of options) {
      if (addOnCountMap[option.name] > 0) {
        pri.selected = option.name;
        addOnCountMap[option.name]--;
        break;
      }
    }
  });
}
            }
                    
                    
                
            
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };
useEffect(() => {
  const mittlens = addOnLists.find(a => a.id === 15 && a.series === "vm1ky38CcV8");

  if (mittlens) {
    const qty = getMittlensQuantity("vm1ky38CcV8");

    setAddOnInputs(prev => ({
      ...prev,
      [mittlens.id]: {
        ...prev[mittlens.id],
        quantity: qty
      }
    }));
  }
}, [items, addOnLists]);

    const getMenuBasedOnId = (id) => {
        return [
            { value: "", label: "Select" },
            ...dropMenu.filter(item => item.id === id || item.id.toString() === id)
                .map(item => ({ value: item.name, label: item.name }))
        ];
    };
  const order = () => {
  const prizeAddOns = prize
    .map(ele => ele.selected)
    .filter(Boolean);

  const seriesWiseAddOns = {};
  // selectedAddOns.forEach(a => {
  //   const addOnItem = addOnLists.find(
  //     ao => ao.name === a.name && ao.series === a.series
  //   );

  //   const addOnId = addOnItem?.id;
  //   const inputs = addOnInputs[addOnId] || {};
  //   const seriesName = getSeriesName(a.series);
  //   if (!seriesWiseAddOns[seriesName]) {
  //     seriesWiseAddOns[seriesName] = [];
  //   }
  //   seriesWiseAddOns[seriesName].push({
  //     name: a.name,
  //     inputs: inputs
  //   });
  // });

selectedAddOns.forEach(a => {
  const addOnItem = addOnLists.find(
    ao => ao.name === a.name && ao.series === a.series
  );

  const addOnId = addOnItem?.id;
  let inputs = addOnInputs[addOnId] || {};

  // ✅ SPECIAL LOGIC FOR MITTLENS
  if (addOnId === 15 && a.series === "vm1ky38CcV8") {
    const qty = getMittlensQuantity("vm1ky38CcV8");

    inputs = {
      ...inputs,
      quantity: qty
    };
  }

  const seriesName = getSeriesName(a.series);

  if (!seriesWiseAddOns[seriesName]) {
    seriesWiseAddOns[seriesName] = [];
  }

  seriesWiseAddOns[seriesName].push({
    name: a.name,
    inputs: inputs
  });
});

  if (prizeAddOns.length > 0) {
    if (!seriesWiseAddOns["Bundle"]) {
      seriesWiseAddOns["Bundle"] = [];
    }
    prizeAddOns.forEach(p => {
      seriesWiseAddOns["Bundle"].push({ name: p });
    });
  }

  const updatedPayload = {
    ...payload,
    addOns: seriesWiseAddOns, // ✅ grouped by series
    onBoardERP: isChecked
  };

  console.log(updatedPayload)
  proceed(updatedPayload);
};

    const groupData = async (items) => {
      const groupedData = {};
      const seriesStats = {};

      items.forEach(item => {
        // const seriesId = item.series;
        const seriesId = item.series || item?.data?.seriesCategory;
        if (!groupedData[seriesId]) {
          groupedData[seriesId] = {
            set: { total: 0.0, count: 0 },
            individual: { total: 0.0, count: 0 }
          };
        }

        const mrp = (Number(item.price) || 0) * (Number(item.qty) || 0);

        const isSet = (item.itemType && item.itemType.toString().toLowerCase().includes('choose from set')) ||
          (item.bookType && item.bookType.toString().toLowerCase().includes('choose from set'));

        if (isSet) {
          groupedData[seriesId].set.total += mrp;
          groupedData[seriesId].set.count++;
        } else {
          groupedData[seriesId].individual.total += mrp;
          groupedData[seriesId].individual.count++;
        }

        if (!seriesStats[seriesId]) {
          seriesStats[seriesId] = { bookCount: 0, setCount: 0, classCounts: {} };
        }

        if (item.bookType && item.bookType.toString().toLowerCase().includes('individual')) {
          seriesStats[seriesId].bookCount++;
        }
        if (item.bookType && item.bookType.toString().toLowerCase().includes('set')) {
          seriesStats[seriesId].setCount++;
        }

        // const classId = item.class;
        const classId = item.class || item?.data?.classId || item?.data?.class;
        if (classId) {
          seriesStats[seriesId].classCounts[classId] = (seriesStats[seriesId].classCounts[classId] || 0) + 1;
        }
      });

      const seriesWiseArray = Object.keys(seriesStats).map(sid => {
        const counts = seriesStats[sid];
        const uniqueClasses = Object.keys(counts.classCounts).length;
        return {
          series: sid,
          bookCount: counts.bookCount,
          setCount: counts.setCount,
          classCount: uniqueClasses,
        };
      });

      console.log('Series wise aggregation:', seriesWiseArray);
                const response = await window.Platform.database.getAddOnProducttWeb1(seriesWiseArray);
                    if (response?.status) {
                        setAddOnProducts(response.data);
                    }
      setConfuse(groupedData);
    };

    const getMittlensQuantity = (seriesId) => {
  const classMap = {};

  items.forEach(item => {
    const sId = item.series || item?.data?.seriesCategory;
    if (sId !== seriesId) return;

    const classId = item.class || item?.data?.classId || item?.data?.class;

    if (!classId) return;

    const qty = Number(item.qty) || 0;

    // Take max per class (important)
    if (!classMap[classId]) {
      classMap[classId] = qty;
    } else {
      classMap[classId] = Math.max(classMap[classId], qty);
    }
  });

  // Sum of unique class quantities
  return Object.values(classMap).reduce((sum, q) => sum + q, 0);
};

    return (
        <div className="container">
            <h2><strong>Add-On Products</strong></h2>
             <label className="addon-card w-25">
                        <input
                            type="checkbox"
                            name="Teachers Mannual"
                            checked={isChecked}
                            onChange={() => setIsChecked(!isChecked)}
                        />
                       <span className='ml-2'> Onboard For ERP </span> 
                    </label>
            {isLoading ? <p>Loading...</p> : (
                <>
                    {prize.length > 0 && (
                        <>
                            <h4 className="mt-4">Bundle Add-Ons</h4>
                            {prize.map((item, index) => (
                                <div key={index} className="card">
                                    <h5>Select {index + 1} Add-on Item</h5>
                                    <p>Series: {item.series}</p>
                                    <select
                                        value={item.selected}
                                        onChange={(e) => {
                                            const newPrize = [...prize];
                                            newPrize[index].selected = e.target.value;
                                            setPrize(newPrize);
                                        }}
                                    >
                                        {getMenuBasedOnId(item.menu).map(option => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                            ))}
                        </>
                    )}
                    
                    {seriesWiseClass && seriesWiseClass.length > 0 && (
                        <>
                            {Object.entries(getAddOnsBySeriesName()).map(([seriesName, addOns]) => (
                                <div key={seriesName} className="mt-4">
                                    <h5 style={{ 
                                        paddingBottom: "10px", 
                                        borderBottom: "2px solid #007bff",
                                        marginBottom: "15px",
                                        color: "#007bff"
                                    }}>
                                        {seriesName}
                                    </h5>
                                    <div className="row">
                                        {addOns?.map((addOn) => {
                                            const isChecked = selectedAddOns.some(
                                                a => a.name === addOn.name && a.series === addOn.series
                                            );
                                            const inputTypes = parseInputTypes(addOn.inputTypes);
                                            return (
                                            <div key={`${addOn.series}-${addOn.id}`} className="col-md-3 mb-3">
                                                <label className="addon-card w-100">
                                                    <input
                                                        type="checkbox"
                                                        checked={isChecked}
                                                        onChange={() => handleChange(addOn)}
                                                    />
                                                    <span className="ml-2">{addOn.name}</span>
                                                </label>
                                                {inputTypes.length > 0 && isChecked && (
                                                  <div style={{ marginTop: "10px", paddingLeft: "20px" }}>
                                                    {inputTypes.map((inputField) => (
                                                      <div key={inputField.name} style={{ marginBottom: "10px" }}>
                                                        <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>
                                                          {inputField.name}
                                                        </label>
                                                        {inputField.type === "number" ? (
                                                          <input
                                                            type="number"
                                                            onWheel={(e)=>e.target.blur()}
                                                            value={addOnInputs[addOn.id]?.[inputField.name] || ""}
                                                            onChange={(e) => handleAddOnInputChange(addOn.id, inputField.name, e.target.value)}
                                                            style={{ width: "100%", padding: "5px", borderRadius: "4px", border: "1px solid #ccc" }}
                                                            placeholder={`Enter ${inputField.name}`}
                                                          />
                                                        ) : (
                                                          <input
                                                            type="text"
                                                            value={addOnInputs[addOn.id]?.[inputField.name] || ""}
                                                            onChange={(e) => handleAddOnInputChange(addOn.id, inputField.name, e.target.value)}
                                                            style={{ width: "100%", padding: "5px", borderRadius: "4px", border: "1px solid #ccc" }}
                                                            placeholder={`Enter ${inputField.name}`}
                                                          />
                                                        )}
                                                      </div>
                                                    ))}
                                                  </div>
                                                )}
                                            </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                </>
            )}

            <button onClick={order} className="btn btn-primary" >Proceed</button>
        </div>
    );
};

export default AddOnProductsScreen;
